<template>
  <div class="container-fluid">
    <titular />
    <vue-bootstrap4-table ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap comentari</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="titol" slot-scope="props">
        <router-link :to="{ path: '/recursos-projecte', query: { id: props.row.id_projecte, filtre: 'tot' } }" target="_blank">{{ props.cell_value }}</router-link>
      </template>
      <template slot="text" slot-scope="props">
        <div style="white-space: break-spaces;">{{ props.cell_value }}</div>
      </template>
      <template slot="nombreCompleto" slot-scope="props">
        <span class="text-nowrap">{{ props.cell_value }}</span>
      </template>
      <template slot="titol" slot-scope="props">
        <span class="text-nowrap"><router-link :to="{ path: '/recursos-projecte', query: { id: props.row.id_projecte, filtre: 'tot' } }" target="_blank">{{ props.cell_value }}</router-link></span>
      </template>
      <template slot="alta_comentari_cell" slot-scope="props">
        <span class="text-nowrap">{{ props.row.alta_comentari_format }}</span>
      </template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar comentari" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar comentari" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar el comentari #<b>{{ props.row.id }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)"><i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar</button>
            </template>
          </modal>
        </div>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>

<style lang="scss"></style>

<script>
export default {
  name: "Comentaris",
  inject: ["formatearDecimales", "exportarTabla", "exportarBolcat", "mostrarBolcat", "actionsExportar", "exportarDatos"],
  data() {
    return {
      loading: {
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Alta comentari",
          name: "alta_comentari_cell",
          filter: {
            type: "simple",
            placeholder: "Filtra Alta comentari",
          },
          sort: true,
          row_text_alignment: "text-center",
          initial_sort: true,
          initial_sort_order: "desc",
        },
        {
          label: "Projecte",
          name: "titol",
          filter: {
            type: "simple",
            placeholder: "Filtra Projecte",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Usuari",
          name: "nombreCompleto",
          filter: {
            type: "simple",
            placeholder: "Filtra Usuari",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Comentari",
          name: "text",
          filter: {
            type: "simple",
            placeholder: "Filtra Comentari",
          },
          row_text_alignment: "text-left",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Tots els comentaris",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
    };
  },
  methods: {
    getData: function () {
      const localeFormat = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      this.$http.get("api/comentaris").then((response) => this.rows = response.data.map(row => ({
        ...row,
        nombreCompleto: row.nom + " " + row.cognoms,
        alta_comentari_format: (new Date(row.alta_comentari)).toLocaleString([], localeFormat),
        alta_comentari_cell: `${row.alta_comentari} ${(new Date(row.alta_comentari)).toLocaleString([], localeFormat)}`,
      })));
    },
    getExportData() {
      const filas = this.$refs.tabla.temp_filtered_results;

      if (!filas.length) return null;

      var filasCompletas = filas.map((fila, i) => ({
        'id': fila.id,
        'alta_comentari': fila.alta_comentari,
        'id_projecte': fila.id_projecte,
        'projecte': fila.titol,
        'id_usuari': fila.id_usuari,
        'usuari': fila.nombreCompleto,
        'comentari': fila.text.replace(/(\n|\r)/g, ' '),
      }));

      filasCompletas.unshift(Object.keys(filasCompletas[0]));

      return filasCompletas;
    },
    exportarTablaPrevio() {
      const data = this.getExportData();

      if (!data) return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap comentari per exportar." });

      this.exportarDatos(this.$route.name, data);
    },
    exportarBolcatPrevio() {
      const data = this.getExportData();

      if (!data) return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap comentari per exportar." });

      this.mostrarBolcat(this.$route.name, data);
    },
    eliminar: function (id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/comentaris/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Comentari eliminat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    cerrarEliminacion: function () {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>
